import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import LoginPage from './pages/galaxy-alpr-login.tsx';
import Dashboard from './pages/galaxy-alpr-dashboard.tsx';
import ResultsPage from './pages/galaxy-alpr-results.tsx';
import StatisticsPage from './pages/galaxy-alpr-statistics.tsx';
import DetectionHistoryPage from './pages/galaxy-alpr-history.tsx';
import UserManagementPage from './pages/galaxy-alpr-users.tsx';
import DocumentationPage from './pages/galaxy-alpr-documentation.tsx';
import DetectionConfigPage from './pages/galaxy-alpr-config.tsx';

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<LoginPage />}/>
        <Route path='/dashboard' element={<Dashboard />}/>
        <Route path='/result' element={<ResultsPage />}/>
        <Route path='/statistics' element={<StatisticsPage />}/>
        <Route path='/history' element={<DetectionHistoryPage />}/>
        <Route path='/users' element={<UserManagementPage />}/>
        <Route path='/documentation' element={<DocumentationPage />}/>
        <Route path='/config' element={<DetectionConfigPage />}/>
      </Routes>
    </Router>
  );
}

export default App;